import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button, Grid, MenuItem, Stack, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState } from "react";
import { OssDataGridFrame } from "../common/OssDataGridFrame";
import { OssSectionPanel } from "../common/OssPanel";

const emptyForm = {
  groupCode: "",
  groupName: "",
  defaultLeadDays: 10,
  defaultBufferDays: 5,
  dayBasis: "BUSINESS",
};

export const OssItemGroupManager = ({ rows = [], loading, onSave }) => {
  const [form, setForm] = useState(emptyForm);
  const update = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  return (
    <OssSectionPanel title="품목군 리드타임">
      <Stack spacing={1.5}>
        <Grid container spacing={1.25}>
          <Grid item xs={6} md={2}>
            <TextField size="small" fullWidth label="코드" value={form.groupCode} onChange={(e) => update("groupCode", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={3}>
            <TextField size="small" fullWidth label="품목군명" value={form.groupName} onChange={(e) => update("groupName", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={1.85}>
            <TextField size="small" type="number" fullWidth label="소요일" value={form.defaultLeadDays} onChange={(e) => update("defaultLeadDays", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={1.85}>
            <TextField size="small" type="number" fullWidth label="버퍼" value={form.defaultBufferDays} onChange={(e) => update("defaultBufferDays", e.target.value)} />
          </Grid>
          <Grid item xs={6} md={2}>
            <TextField select size="small" fullWidth label="기준" value={form.dayBasis} onChange={(e) => update("dayBasis", e.target.value)}>
              <MenuItem value="BUSINESS">영업일</MenuItem>
              <MenuItem value="CALENDAR">달력일</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6} md={1.3}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<AddRoundedIcon />}
              disabled={loading}
              onClick={() => onSave(form).then(() => setForm(emptyForm))}
              sx={{ height: 40, minWidth: 92, whiteSpace: "nowrap", "& .MuiButton-startIcon": { mr: 0.5 } }}
            >
              추가
            </Button>
          </Grid>
        </Grid>
        <OssDataGridFrame height={260}>
          <DataGrid
            disableRowSelectionOnClick
            rows={rows}
            getRowId={(row) => row.item_group_id}
            columns={[
              { field: "group_code", headerName: "코드", flex: 0.7 },
              { field: "group_name", headerName: "품목군", flex: 1.2 },
              { field: "default_lead_days", headerName: "소요일", flex: 0.7 },
              { field: "default_buffer_days", headerName: "버퍼", flex: 0.7 },
              { field: "day_basis", headerName: "계산 기준", flex: 0.8 },
            ]}
            loading={loading}
            hideFooter={rows.length <= 10}
          />
        </OssDataGridFrame>
      </Stack>
    </OssSectionPanel>
  );
};
